
Shopify = Shopify || {}
Shopify.theme = Shopify.theme || {}
/*************** DOM ***************/
Shopify.theme.dom = {
    init : function(){
        let that = this;
        if(document.querySelector('external-video')){
            let iframe_api = document.createElement('script');
            iframe_api.id = 'iframe_api';
            iframe_api.src = "https://www.youtube.com/iframe_api";
            document.head.appendChild(iframe_api);
        }
    },
};
Shopify.theme.dom.init();
/*************** LINKS ***************/
Shopify.theme.links = {
    init : function(){
        Shopify.theme.links.scrollToView();
    },
    /*************** SCROLL TO VIEW ***************/
    scrollToView : function(){
        document.querySelectorAll('a').forEach(
            element => {
                if(element.href != ''){
                    let url = new URL(element.href)
                    if(url.hash != '' && url.pathname == location.pathname){
                        element.addEventListener('click',function(event){
                            //event.preventDefault()
                            if(!!document.querySelector(url.hash))
                                window.scrollTo(0,document.querySelector(url.hash).offsetTop)
                        })
                    }
                }
            }
        )
        window.addEventListener('load',function(){
            if(location.hash != ''){
                let url = location;
                if(!!document.querySelector(url.hash)){
                    window.scrollTo(0,document.querySelector(url.hash).offsetTop)
                    history.replaceState({}, document.title, window.location.pathname + window.location.search);
                }
            }
        })
    }
}
Shopify.theme.links.init();
/*************** TOOLS ***************/
Shopify.theme.tools = {
    handleize: function(value){
        let handle =  value.toString().split(' ').join('-');
        handle = handle.toLowerCase();
        return handle
    },
    formatMoney: function (cents, format){
        let placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        let money_format = format;
        switch(money_format.match(placeholderRegex)[1]) {
            case 'amount':
                value = formatWithDelimiters(cents, 2, ",", ".");
                break;
            case 'amount_no_decimals':
                value = formatWithDelimiters(cents, 0);
                break;
            case 'amount_with_comma_separator':
                value = formatWithDelimiters(cents, 2, ".", ",");
                break;
            case 'amount_no_decimals_with_comma_separator':
                value = formatWithDelimiters(cents, 0, ".", ",");
                break;
            case "amount_with_apostrophe_separator":
                value = formatWithDelimiters(cents, 2, "'", ".");
                break;
        }

        function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = (typeof precision != 'undefined' ? precision : 2);
            thousands = (typeof thousands != 'undefined' ? thousands : ".");
            decimal   = (typeof decimal != 'undefined' ? decimal : ",");

            if (isNaN(number) || number == null) { return 0; }

            number = (number/100.0).toFixed(precision);

            var parts   = number.split('.');
            let dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
            let cents   = parts[1] ? (decimal + parts[1]) : '';

            return dollars + cents;
        }
        return money_format.replace(placeholderRegex, value)
    },
    /*************** SHOPIFY COMMON.JS (PROVINCE SELECTOR) ***************/
    bind: function(t,e){
        return function(){
          return t.apply(e,arguments)
        }
    },
    setSelectorByValue: function(t,e){
        for(var n=0,i=t.options.length;n<i;n++)
        {
            var o=t.options[n];
            if(e==o.value||e==o.innerHTML)
                return t.selectedIndex=n
        }
    },
    postLink: function(t,e){
        var n = ( e = e || {}).method || "post";
        i = e.parameters || {};
        o = document.createElement("form");
        for(var r in o.setAttribute("method", n),o.setAttribute("action",t),i){
            var l = document.createElement("input");
            l.setAttribute("type","hidden");
            l.setAttribute("name",r);
            l.setAttribute("value",i[r]);
            o.appendChild(l)
        }
        document.body.appendChild(o);
        o.submit();
        document.body.removeChild(o);
    }
}

Shopify.theme.tools.CountryProvinceSelector = function(t,e,n){
    this.countryEl = document.getElementById(t);
    this.provinceEl = document.getElementById(e);
    this.provinceContainer = document.getElementById(n.hideElement||e);
    this.countryEl.addEventListener('change', Shopify.theme.tools.bind(this.countryHandler, this));
    this.initCountry();
    this.initProvince();
}

Shopify.theme.tools.CountryProvinceSelector.prototype = {
    initCountry: function(){
        var t = this.countryEl.getAttribute("data-default");
        Shopify.theme.tools.setSelectorByValue(this.countryEl,t);
        this.countryHandler();
    },
    initProvince: function(){
        if(!!this.provinceEl){
            var t=this.provinceEl.getAttribute("data-default");
            t && 0 < this.provinceEl.options.length && Shopify.theme.tools.setSelectorByValue(this.provinceEl,t);
        }
    },
    countryHandler: function(){
        var t=(i=this.countryEl.options[this.countryEl.selectedIndex]).getAttribute("data-provinces");
        e=JSON.parse(t);
        if(this.clearOptions(this.provinceEl),e&&0==e.length){
            if(!!this.provinceContainer)
                this.provinceContainer.style.display="none";
        }
        else{
            for(var n=0;n<e.length;n++){
                var i = document.createElement("option").value = e[n][0];
                i.innerHTML=e[n][1];
                if(!!this.provinceEl)
                    this.provinceEl.appendChild(i);
            }
            if(!! this.provinceContainer)
                this.provinceContainer.style.display = "";
        }
    },
    clearOptions: function(t){
        if(!!t && !!t.firstChild)
            t.removeChild(t.firstChild);
    },
    setOptions: function(t,e){
        var n=0;
        for(e.length;n<e.length;n++){
            var i=document.createElement("option");
            i.value = e[n];
            i.innerHTML = e[n];
            t.appendChild(i);
        }
    }
}

Shopify.currency.moneyFormat = null;
/*************** CART ***************/
Shopify.theme.cart = {
  sections: ['cart_drawer', 'cart_main'],
  init : function(){
    window.addEventListener('cart:add',function(e){
      e.preventDefault();
      if ('drawer' == 'redirect') {
        location.pathname = window.Shopify.routes.cartUrl
      }
      else if ('drawer' == 'drawer') {
        window.dispatchEvent(new CustomEvent("cart:drawer:open"));
      }
    })
  },
  /**
      * Callback to do custom responsehandling for all cart api calls 
      * @callback cartCallback
      * @param {Object} response
  */
  /**
      * Adds items to cart.
      * @param {boolean} itemsToAdd - products to add example: {items:[{id: variant.id, quantity: variant.quantity}]}
      * @param {boolean} events - fire cart:add event default true.
      * @param {cartCallback} callback - the callback that handles the response.
  */
  addToCart : function (itemsToAdd, events = true, callback = (cart) => {}) {
    const url = window.Shopify.routes.cartAddUrl + '?sections=' + this.sections.join(',');
    fetch(url, {
      body: JSON.stringify(itemsToAdd),
      credentials: 'same-origin',
      headers: {'Content-Type': 'application/json', 'Accept':'application/json', 'X-Requested-With': 'XMLHttpRequest'},
      method: 'POST'
    }).then(function(response) {
      return response.json();
    }).then(function(response) {
      if(response.status){
        if(events){
          window.dispatchEvent(new CustomEvent("cart:add", {detail:{}}));
        }
        const error_string = `\nCART ADD FAILED \nStatus: ${response.status} \nMessage: ${response.message} \nDescription: ${response.description}`;
        throw new Error(error_string, { cause: 'Cart Error' });
      } else {
        callback(response);
        if(events){
          window.dispatchEvent(new CustomEvent("cart:add", {detail:{...response}}));
        }
      }
    }).catch(function(err) {
      console.error(err);
    });
  },
  /**
      * Gets the cart and provides it via events.
      * @param {boolean} events - fire cart:add event default true.
      * @param {cartCallback} callback - the callback that handles the response.
  */
  getCart: function (events = true, callback = (cart) => {}){
    const url = window.Shopify.routes.cartUrl + '?sections=' + this.sections.join(',');
    fetch(window.Shopify.routes.cartUrl, {
      credentials: 'same-origin',
      headers: {'Content-Type': 'application/json', 'Accept':'application/json', 'X-Requested-With': 'XMLHttpRequest'},
      method: 'GET'
    }).then(function(response) {
      return response.json();
    }).then(function(response) {
      if(response.status){
        const error_string = `\nCART GET FAILED \nStatus: ${response.status} \nMessage: ${response.message} \nDescription: ${response.description}`;
        throw new Error(error_string, { cause: 'Cart Error' });
      } else {
        callback(response);
        if(events){
          window.dispatchEvent(new CustomEvent("cart:changed", {detail:{...response}}));
        }
      }
    }).catch(function(err) {
      console.error(err)
    });
  },
  /**
      * Updates one or multiple line_items either by specifying the line_index or the variant.id.
      * @param {boolean} itemsToUpdate - items to update example: {updates:{variant.id: 2}}
      * @param {boolean} events - fire cart:add event default true.
      * @param {cartCallback} callback - the callback that handles the response.
  */
  updateCart: function (itemsToUpdate, events = true, callback = (cart) => {}){
    const url = window.Shopify.routes.cartUpdateUrl + '?sections=' + this.sections.join(',');
    fetch(url, {
      body: JSON.stringify(itemsToUpdate),
      credentials: 'same-origin',
      headers: {'Content-Type': 'application/json', 'Accept':'application/json', 'X-Requested-With': 'XMLHttpRequest'},
      method: 'POST'
    }).then(function(response) {
      return response.json();
    }).then(function(response) {
      if(response.status){
        const error_string = `\nCART UPDATE FAILED \nStatus: ${response.status} \nMessage: ${response.message} \nDescription: ${response.description}`;
        throw new Error(error_string, { cause: 'Cart Error' });
      } else {
        callback(response);
        if(events){
          window.dispatchEvent(new CustomEvent("cart:changed", {detail:{...response}}));
        }
      }
    }).catch(function(err) {
      console.error(err)
    });
  },
  /**
      * Clears the cart and returns the empty cart via events.
      * @param {boolean} events - fire cart:add event default true.
      * @param {cartCallback} callback - the callback that handles the response.
  */
  clearCart: function (events = true, callback = (cart) => {}){
    const url = window.Shopify.routes.cartClearUrl + '?sections=' + this.sections.join(',');
    fetch(url, {
      body: '',
      credentials: 'same-origin',
      headers: {'Content-Type': 'application/json', 'Accept':'application/json', 'X-Requested-With': 'XMLHttpRequest'},
      method: 'POST'
    }).then(function(response) {
      return response.json();
    }).then(function(response) {
      if(response.status){
        const error_string = `\nCART CLEAR FAILED \nStatus: ${response.status} \nMessage: ${response.message} \nDescription: ${response.description}`;
        throw new Error(error_string, { cause: 'Cart Error' });
      } else {
        callback(response);
        if(events){
          window.dispatchEvent(new CustomEvent("cart:changed", {detail:{...response}}));
        }
      }
    }).catch(function(err) {
      console.error(err)
    });
  },
  /**
      * Change quantity or properties of a line_item with a given variant.key.
      * @param {boolean} itemToChange - item to change example: {id: variant.key, quantity: variant.quantity}
      * @param {boolean} events - fire cart:add event default true.
      * @param {cartCallback} callback - the callback that handles the response.
  */
  changeItem: function (itemToChange, events = true, callback = (cart) => {}){
    const url = window.Shopify.routes.cartChangeUrl + '?sections=' + this.sections.join(',');
    fetch(url, {
      body:  JSON.stringify(itemToChange),
      credentials: 'same-origin',
      headers: {'Content-Type': 'application/json', 'Accept':'application/json', 'X-Requested-With': 'XMLHttpRequest'},
      method: 'POST'
    }).then(function(response) {
      return response.json();
    }).then(function(response) {
      if(response.status){
        const error_string = `\nCART CHANGE FAILED \nStatus: ${response.status} \nMessage: ${response.message} \nDescription: ${response.description}`;
        throw new Error(error_string, { cause: 'Cart Error' });
      } else {
        callback(response);
        if(events){
          window.dispatchEvent(new CustomEvent("cart:changed", {detail:{...response}}));
        }
      }
    }).catch(function(err) {
      console.error(err)
    });
  }
};
Shopify.theme.cart.init();
class CustomDOMParser{
    constructor(){

    }
    parseFromString(string, format = 'text/html'){
        let div = document.createElement('div')
        if(format == 'text/html'){
            div.innerHTML = string;
            return div;
        }
        else{
            console.error('CustomDOMParser: Format not supported!')
        }
    }
}